// Only product identifiers are remembered. Cards and prices come from Shopify at display time.
(() => {
  if (window.AplovioRecentProducts) return;
  const key = 'aplovio:recent-products:v1';
  const lifetime = 30 * 24 * 60 * 60 * 1000;
  const validHandle = value => typeof value === 'string' && /^[\p{L}\p{N}][\p{L}\p{N}-]{0,254}$/u.test(value);
  let memory = [];
  function permitted() {
    return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() !== false;
  }
  function clean(entries) {
    const seen = new Set(), now = Date.now();
    if (!Array.isArray(entries)) return [];
    return entries.filter(item => {
      if (!item || !validHandle(item.handle) || !/^\d+$/.test(String(item.id)) || !Number.isFinite(item.at) || item.at > now || now - item.at > lifetime || seen.has(item.handle)) return false;
      seen.add(item.handle);
      return true;
    }).slice(0, 40).map(({id, handle, at}) => ({id: String(id), handle, at}));
  }
  function read() {
    if (!permitted()) return clean(memory);
    try {
      const stored = JSON.parse(localStorage.getItem(key) || 'null');
      if (stored?.version === 1) memory = clean(stored.items);
    } catch { /* Disabled storage or malformed old state falls back to this page's memory. */ }
    return clean(memory);
  }
  function record(owner) {
    if (window.Shopify?.designMode || document.documentElement.dataset.recentlyViewed === 'false' || !owner?.isConnected) return;
    let url;
    try { url = new URL(owner.dataset.productUrl, location.href); decodeURIComponent(url.pathname); }
    catch { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    const handle = decodeURIComponent(url.pathname.split('/').filter(Boolean).at(-1));
    const id = owner.dataset.productGid?.split('/').at(-1);
    if (!validHandle(handle) || !/^\d+$/.test(id || '')) return;
    const entries = read();
    memory = [{id, handle, at: Date.now()}, ...entries.filter(item => item.handle !== handle)].slice(0, 40);
    if (permitted()) {
      try { localStorage.setItem(key, JSON.stringify({version: 1, items: memory})); }
      catch { /* Private browsing or quota limits retain a bounded in-memory history. */ }
    }
  }
  function entries(exclude, limit = 20) {
    let encodedLength = 0;
    return read().filter(item => {
      if (item.id === String(exclude)) return false;
      encodedLength += encodeURIComponent(item.handle).length + 3;
      return encodedLength <= 4000;
    }).slice(0, Math.max(1, Math.min(20, Number(limit) || 20)));
  }
  window.AplovioRecentProducts = {entries};
  document.addEventListener('aplovio:product-ready', event => record(event.target));
  const recordCurrent = () => document.querySelectorAll('aplovio-product[data-product-url]').forEach(record);
  document.addEventListener('aplovio:mobile-product-view', recordCurrent);
  document.addEventListener('aplovio:product-route', recordCurrent);
  window.addEventListener('pageshow', recordCurrent);
  document.addEventListener('visitorConsentCollected', () => {
    if (!permitted()) {
      memory = [];
      try { localStorage.removeItem(key); } catch { /* Storage may already be unavailable. */ }
    }
  });
  recordCurrent();
})();
